// Stripe redirects here as soon as Checkout completes, but delayed payment
// methods (Pix, boleto) complete the Checkout Session while it is still
// unpaid. The page therefore asks Payhook's pull endpoint whether the hook is
// actually entitled before claiming success, and keeps asking for a bounded
// window while the payment clears.

// Mirrors the SDK's entitlement rule (payhook-js core/entitlement.js).
const ACTIVE_STATUSES = new Set(['active', 'trialing', 'past_due'])

// A Pix payment confirms seconds after the buyer approves it in the bank app,
// so 4 s keeps the wait short. Five minutes covers a slow bank app; boleto
// takes business days and is not worth polling for.
const POLL_INTERVAL_MS = 4000
const POLL_WINDOW_MS = 5 * 60 * 1000

function hasActiveEntitlement (payments) {
  if (!Array.isArray(payments)) return false
  return payments.some((payment) => Boolean(
    payment &&
    payment.confirmedAt &&
    ACTIVE_STATUSES.has(payment.status)
  ))
}

// Resolves 'active' once pull reports an entitlement, or 'pending' when the
// window runs out. Pull errors during the window are treated as "not yet".
async function waitForEntitlement ({
  pull,
  intervalMs = POLL_INTERVAL_MS,
  windowMs = POLL_WINDOW_MS,
  now = () => Date.now(),
  sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms))
}) {
  const deadline = now() + windowMs
  while (now() < deadline) {
    await sleep(intervalMs)
    try {
      if (hasActiveEntitlement(await pull())) return 'active'
    } catch {
      // Transient API/Stripe hiccup: keep polling until the window closes.
    }
  }
  return 'pending'
}

module.exports = {
  ACTIVE_STATUSES,
  POLL_INTERVAL_MS,
  POLL_WINDOW_MS,
  hasActiveEntitlement,
  waitForEntitlement
}
